import { getClaimStatus } from '../utils/statusConfig.mjs';

/**
 * The claimant's own status banner.
 *
 * Reads the shared vocabulary with `self: true`, so the wording is addressed to
 * the person who filed the claim: 'under_review' says "With Admin (Auditor
 * Query)" and states that no action is needed, rather than the admin-facing
 * "Admin to Fix".
 *
 * It used to carry a private five-status map with bracketed letter icons, so
 * 'under_review', 'paid' and legacy 'pending' all fell through to a literal
 * "[?] under_review" - a raw database token shown to a claimant, on exactly the
 * states where they most need to know whether to act. The one-line description
 * now always answers that.
 */
export const ClaimStatusBanner = ({ claimStatus, isNewClaim }) => {
  // Don't show the banner for new claims
  if (isNewClaim) return null;

  const status = getClaimStatus(claimStatus, { self: true });

  // No buttons (the user, 2026-10-22). A draft or a returned claim opens
  // already editable, so "Edit Claim" and then "Edit and Resubmit" did
  // nothing but flip a label - the claimant edits the form and resubmits it
  // with the form's own Submit. Every other status is somebody else's turn,
  // which the description says.
  return (
    <div className={`${status.bg} border ${status.border} rounded-xl p-4 mb-6 max-sm:mb-4`}>
      <p className="text-lg font-semibold text-gray-900">{status.label}</p>
      {status.description && (
        <p className="text-sm text-gray-700 mt-1">{status.description}</p>
      )}
    </div>
  );
};

export default ClaimStatusBanner;
